"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileIcon = FileIcon;
/** @jsx jsx */
var core_1 = require("@emotion/core");
var react_1 = __importDefault(require("react"));
var colors = {
    red: "#F15642",
    orange: "#f7b84d",
    green: "#84BD5A",
    blue: "#50BEE8",
    purple: "#A066AA",
    grey: "#576D7E",
};
var fileTypeColors = {
    mov: colors.blue,
    zip: colors.green,
    txt: colors.grey,
    js: colors.grey,
    mid: colors.purple,
    midi: colors.purple,
    aac: colors.red,
    psd: colors.blue,
    ps: colors.orange,
    bmp: colors.green,
    eps: colors.orange,
    jpg: colors.blue,
    jpeg: colors.blue,
    flv: colors.orange,
    xml: colors.blue,
    html: colors.green,
    svg: colors.orange,
    xls: colors.green,
    wmv: colors.green,
    ppt: colors.red,
    fla: colors.red,
    "3ds": colors.green,
    css: colors.grey,
    ai: colors.orange,
    sql: colors.red,
    php: colors.grey,
    raw: colors.grey,
    dat: colors.green,
    mpg: colors.orange,
    mpeg: colors.orange,
    pdf: colors.red,
    gif: colors.purple,
    tif: colors.purple,
    dmg: colors.grey,
    iso: colors.blue,
    avi: colors.red,
    cad: colors.blue,
    mp3: colors.blue,
    doc: colors.blue,
    docx: colors.blue,
    indd: colors.purple,
    png: colors.purple,
    cdr: colors.green,
    dll: colors.grey,
};
/** Displays a file icon SVG, including the extension if given. */
function FileIcon(_a) {
    var _b;
    var extension = _a.extension, error = _a.error, width = _a.width, height = _a.height;
    extension = extension === null || extension === void 0 ? void 0 : extension.replace(/^\./, "");
    var pagePath = "M128 0c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V128L352 0H128z";
    var cutoutPath = "M200 0l20 100l-20 100l20 100l-20 100l20 100l0 -100l40 -100l-10 -100l50 -100l-5 -100z";
    return ((0, core_1.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", x: "0", y: "0", enableBackground: "new 0 0 512 512", version: "1.1", viewBox: "0 0 512 512", xmlSpace: "preserve", css: (0, core_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: inline-block;\n        ", "\n        ", "\n        opacity: ", ";\n      "], ["\n        display: inline-block;\n        ", "\n        ", "\n        opacity: ", ";\n      "])), width && "width: ".concat(width, "px;"), height && "height: ".concat(height, "px;"), error ? 0.7 : 1) },
        error ? ((0, core_1.jsx)("path", { fill: "#E2E5E7", fillRule: "evenodd", d: pagePath + cutoutPath })) : ((0, core_1.jsx)("path", { fill: "#E2E5E7", d: pagePath })),
        (0, core_1.jsx)("path", { fill: "#B0B7BD", d: "M384 128h96L352 0v96c0 17.6 14.4 32 32 32z" }),
        (0, core_1.jsx)("path", { fill: "#CAD1D8", d: "M480 224L384 128 480 128z" }),
        extension && ((0, core_1.jsx)("path", { fill: "#CAD1D8", d: "M400 432H96v16h304c8.8 0 16-7.2 16-16v-16c0 8.8-7.2 16-16 16z" })),
        error && (0, core_1.jsx)("path", { fill: "rgba(0,0,0,0.2)", fillRule: "evenodd", d: pagePath + cutoutPath }),
        extension && ((0, core_1.jsx)(react_1.default.Fragment, null,
            (0, core_1.jsx)("path", { fill: (_b = fileTypeColors[extension.toLowerCase()]) !== null && _b !== void 0 ? _b : fileTypeColors.txt, d: "M416 416c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v160z" }),
            (0, core_1.jsx)("text", { x: "44%", y: "75%", fontFamily: "Lucida Console, Menlo, monospace", fontSize: "9em", textAnchor: "middle", fill: "white" }, extension.toUpperCase())))));
}
var templateObject_1;
